module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "snow-projections-median.358ebb24.jpg";